import * as React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import AuthContext from './AuthContext.js';
import { doSignOut } from './utils/reducers.js';
import { isAuthenticated } from './utils/utils.js';

/**
 * Private Route for Components
 *
 * @remarks
 * This Component is based on {@link https://reactrouter.com/web/api/Route | reactrouter.Route}.
 * So you need to install react-route-dom before use it
 *
 * @param props
 */
var RequireAuth = function (_a) {
    var children = _a.children, loginPath = _a.loginPath, roles = _a.roles;
    var context = React.useContext(AuthContext);
    if (context === null) {
        throw new Error('Auth Provider is missing. ' +
            'Please add the AuthProvider before Router');
    }
    var location = useLocation();
    if (!isAuthenticated(context.authState)) {

        // context.dispatch(doSignOut());
        return React.createElement(Navigate, { to: loginPath, state: { from: location }, replace: true });
    }
    if (roles) {

        if (roles.includes(context?.authState?.userState?.role)) {
            return children;
        } else {
            window.location.replace("/");
        }
    } else {
        return children;
    }
};

export default RequireAuth;